import React from 'react';
import { Create } from 'react-admin';
import ProductForm from './ProductsForm';

export default ({ ...props }) => {
  
  return <Create {...props} title="Aggiungi prodotto">
    <ProductForm redirect="edit" />
  </Create>
}